import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, ssoLoginGuard } from '@gs-2.0/core';
import { authenticatedRedirectGuard, globalConfigResolver, portalAccessGuard } from '@gs-2.0/portal';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.HomeModule),
  },
  {
    path: 'about',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.AboutModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ContactModule),
  },
  {
    path: 'search',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.SearchResultsModule),
  },
  {
    path: 'charities',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.CharityCatalogModule),
  },
  {
    path: 'projects',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ProjectCatalogModule),
  },
  {
    path: 'giving-info',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.GivingInfoModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.DashboardModule),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.AuthModule),
  },
  {
    path: 'sso',
    canActivate: [ssoLoginGuard],
    loadComponent: () =>
      import('@gs-2.0/features').then((m) => m.SsoRedirectComponent),
  },
  {
    path: 'profile',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ProfileModule),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.SettingsModule),
    canActivate: [authGuard],
  },
  {
    path: 'fund',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.FundLayoutModule),
    canActivate: [authGuard, portalAccessGuard],
  },
  {
    path: 'translations',
    loadComponent: () => import('@gs-2.0/features').then((m) => m.TranslationManagerComponent),
  },
  {
    path: 'charity/:uuid/:language/:tab',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.CharityModule),
  },
  {
    path: 'project/:uuid/:language/:tab',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ProjectModule),
  },
  {
    path: 'project/:uuid/:language',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ProjectModule),
  },
  {
    path: 'project/:uuid',
    loadChildren: () => import('@gs-2.0/features').then((m) => m.ProjectModule),
  },
  {
    path: 'public/donate',
    loadChildren: () => import('@gs-2.0/portal').then((m) => m.DonateModule),
    canActivate: [authenticatedRedirectGuard],
    resolve: {
      globalConfig: globalConfigResolver,
    },
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: undefined,
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
